var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'a-button': true,
    'a-button_main': _vm.main,
    'a-button_additional': _vm.additional,
    'a-button_disabled': _vm.disabled,
    ['a-button_' + _vm.icon]: _vm.icon,
    ['a-button_' + _vm.accordion]: _vm.accordion,
    ['a-button_' + _vm.variant]: !_vm.disabled && _vm.variant,
    ['a-button_' + _vm.mod]: !_vm.main && _vm.mod,
  },on:{"click":() => {
      if (!this.disabled) this.$emit('click');
    }}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }